import styled from 'styled-components';

export const StyledBurger = styled.button`
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 50px;
  height: 45px;
  background: transparent;
  border: none;
  cursor: pointer;  
  z-index: 10;  
  background: none;
  border: 0px red solid;
  
`;
